import { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { Icon } from '@iconify/react';
import { Brand } from './Brand';
import { ThemeToggle } from './ThemeToggle';
import { useSite } from '../lib/site-context';
import type { MenuItem } from '../lib/types';

const fallbackLinks: MenuItem[] = [
  { id: 'home', href: '/', label: 'Início', target: '_self', sortOrder: 10, active: 1 },
  { id: 'services', href: '/servicos', label: 'Soluções', target: '_self', sortOrder: 20, active: 1 },
  { id: 'tech', href: '/tecnologias', label: 'Tecnologias', target: '_self', sortOrder: 30, active: 1 },
  { id: 'portfolio', href: '/portfolio', label: 'Portfólio', target: '_self', sortOrder: 40, active: 1 },
  { id: 'about', href: '/sobre', label: 'Sobre', target: '_self', sortOrder: 50, active: 1 },
  { id: 'faq', href: '/faq', label: 'FAQ', target: '_self', sortOrder: 60, active: 1 },
  { id: 'contact', href: '/contato', label: 'Contato', target: '_self', sortOrder: 70, active: 1 },
];

export function Header() {
  const [open, setOpen] = useState<boolean>(false);
  const { site } = useSite();
  const items = Array.isArray(site.menu) && site.menu.length > 0 ? site.menu : fallbackLinks;

  const childrenOf = (parentId?: string) =>
    items
      .filter((item) => (item.parentId ?? null) === (parentId ?? null))
      .sort((a, b) => a.sortOrder - b.sortOrder);

  return (
    <header className="site-header">
      <div className="container nav-wrap">
        <Brand />

        {/* Botão Mobile */}
        <button
          className="menu-button"
          aria-expanded={open}
          aria-controls="main-nav"
          aria-label={open ? 'Fechar menu' : 'Abrir menu'}
          onClick={() => setOpen((value) => !value)}
        >
          <Icon icon={open ? 'lucide:x' : 'lucide:menu'} width="22" height="22" />
        </button>

        {/* Navegação */}
        <nav id="main-nav" className={`main-nav ${open ? 'is-open' : ''}`} aria-label="Navegação principal">
          {childrenOf().map((item) => {
            const children = childrenOf(item.id);
            return (
              <div className={`nav-item ${children.length ? 'has-children' : ''}`} key={item.id}>
                <NavLink
                  to={item.href}
                  target={item.target || '_self'}
                  end={item.href === '/'}
                  onClick={() => setOpen(false)}
                  className={({ isActive }) => (isActive ? 'active' : undefined)}
                >
                  <span>{item.label}</span>
                  {children.length > 0 && (
                    <Icon icon="lucide:chevron-down" width="14" height="14" style={{ marginLeft: '4px' }} />
                  )}
                </NavLink>

                {children.length > 0 && (
                  <div className="submenu" role="menu">
                    {children.map((child) => (
                      <NavLink
                        key={child.id}
                        role="menuitem"
                        to={child.href}
                        target={child.target || '_self'}
                        onClick={() => setOpen(false)}
                      >
                        {child.label}
                      </NavLink>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </nav>

        <ThemeToggle />

        <NavLink className="btn btn-primary header-cta" to="/contato">
          <span>Solicitar orçamento</span>
          <Icon icon="lucide:arrow-right" width="16" height="16" aria-hidden="true" />
        </NavLink>
      </div>
    </header>
  );
}